import script from "./ConnectNumberButton.vue?vue&type=script&setup=true&lang=js"
export * from "./ConnectNumberButton.vue?vue&type=script&setup=true&lang=js"

import "./ConnectNumberButton.vue?vue&type=style&index=0&id=97d7ecec&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-97d7ecec"]])

export default __exports__